<template>
  <DialogTemplate :desktopFullscreen="true">
    <portal-target :name="dialog.portaltarget" />
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'ChartDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
}
</script>
